// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-credit-line' class="box">
    <sub-header header="'Credit lines'">
     <div class="right-header-panel" ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'">
       <div class="switch">
          <input id="closed-table-switch"
                 type="checkbox"
                 ng-model="\$ctrl.showClosed"
                 ng-click="\$ctrl.toggleShowClosed()"
                 ng-disabled="\$ctrl.onlyClosedCreditLines()"/>
          <label for="closed-table-switch">Show closed credit lines</label>
        </div>
       <button command-access="CreateCreditLine"  ng-if="\$ctrl.profile.creditLineAllowed" class="btn btn-primary" ng-click="\$ctrl.createNew()">Create new</button>
     </div>
    </sub-header>

    <customer-nongroup-access ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'"></customer-nongroup-access>

    <form-section ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'">
        <span class="label">Credit line allowed for customer?</span>
        <select command-access="SwitchCustomerCreditLine" ng-model="\$ctrl.creditLineEnabled"
                ng-change="\$ctrl.toggleCreditLineAllowed()"
                boolean-options>
        </select>
    </form-section>

    <div ng-if="\$ctrl.profile.creditLineAllowed" class="container--with-mini-menu">

      <div>
        <table class="table accordion collapse-borders" id="accordion">
          <thead>
            <tr>
              <th>No</th>
              <th>Credit Line Number</th>
              <th>Description</th>
              <th>Status</th>
              <th>Approved Credit Line</th>
              <th>Utilized</th>
              <th>Unused</th>
              <th>Total Loans</th>
            </tr>
          </thead>
          <tbody class="accordion-group" ng-repeat="item in \$ctrl.visibleCreditLines">
            <tr
              class="accordion-heading accordion-toggle"
              data-toggle="collapse"
              data-parent="#accordion"
              data-target="#{{'cl-loans-' + \$index}}"
              ng-click="\$ctrl.selectCreditLine(item)"
              ng-class="{'selected': item == \$ctrl.selectedCreditLine}"
            >
              <td>{{\$index + 1}}</td>
              <td>{{item.creditLineNumber}}</td>
              <td>{{item.description}}</td>
              <td>{{item.status}}</td>
              <td>{{item.approvedCreditLine | nxCurrency}}</td>
              <td>{{item.availedCreditLine | nxCurrency}}</td>
              <td>{{item.unusedCreditLine | nxCurrency}}</td>
              <td>{{item.loans.length}}</td>
              <td>
                <i class="flex-end" ng-class="item === \$ctrl.selectedCreditLine ? 'icon-chevron-down' : 'icon-chevron-up'"></i>
              </td>
            </tr>
            <tr>
              <td colspan="9" class="remove-padding">
                <div class="accordion-body collapse" id="{{'cl-loans-' + \$index}}">
                  <batch-individual-loans batches="[item]"></batch-individual-loans>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mini-menu right-details" ng-show="\$ctrl.selectedCreditLine">

        <ul class="nav-tabs">
          <li class="active">
            <a data-target="#operations" data-toggle="tab">Operations</a>
          </li>
          <li>
            <a data-target="#details" data-toggle="tab">Details</a>
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="operations">
            <div class="operation-row">
              <!--manage borrowers-->
              <button class="btn btn-success" ng-if="\$ctrl.profile.customerType === 'CORPORATE'" command-access="ManageCreditLineBorrowers" ng-disabled="\$ctrl.selectedCreditLine.status !== 'ACTIVE'" ng-click="\$ctrl.manageBorrowers()">Manage borrowers</button>

              <!--edit credit-line-->
              <button ng-disabled="\$ctrl.selectedCreditLine.status === 'CLOSED'" command-access="UpdateCreditLine" class="btn btn-warning" ng-click="\$ctrl.editCreditLine()">Edit</button>

              <button command-access="BlockCreditLine"
                      class="btn btn-danger"
                      ng-if="\$ctrl.selectedCreditLine.status === 'ACTIVE'"
                      ng-click="\$ctrl.blockCreditLine()">Block</button>

              <button command-access="UnblockCreditLine"
                      class="btn btn-success"
                      ng-if="\$ctrl.selectedCreditLine.status === 'BLOCKED'"
                      ng-click="\$ctrl.unblockCreditLine()">Unblock</button>

              <!--delete credit-line-->
              <button command-access="DeleteCreditLine" class="btn btn-danger" ng-click="\$ctrl.deleteCreditLine()">Delete</button>


              <!--close credit line-->
              <button ng-disabled="\$ctrl.selectedCreditLine.status === 'CLOSED'" class="btn btn-danger" command-access="CloseCreditLine" ng-click="\$ctrl.closeCreditLine()">Close</button>
            </div>
          </div>

          <div class="tab-pane" id="details">
            <div class="info-detail">
              <div class="info-detail">
                <span class="key">CIF Name: </span>
                <span class="value">{{\$ctrl.profile.effectiveName}}</span>
              </div>
              <div class="info-detail">
                <span class="key">Address:</span>
                <span class="value">{{(\$ctrl.profile.primaryAddress | prettyAddress) || '-'}}</span>
              </div>
              <div class="info-detail">
                <span class="key">Status:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.status}}</span>
              </div>
              <div class="info-detail">
                <span class="key">Type:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.replenishmentType | prettyEnum}}</span>
              </div>
              <div class="info-detail">
                <span class="key">Grant date:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.grantDate | prettyDate}}</span>
              </div>
              <div class="info-detail">
                <span class="key">Expiration date:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.expirationDate | prettyDate}}</span>
              </div>
              <div class="info-detail">
                <span class="key">Availed:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.availedRate}}%</span>
              </div>
              <div class="info-detail">
                <span class="key">Unused:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.unusedRate}}%</span>
              </div>
              <div class="info-detail">
                <span class="key">Created by:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.user.effectiveName}}</span>
              </div>
              <div class="info-detail">
                <span class="key">Created in branch:</span>
                <span class="value">{{\$ctrl.selectedCreditLine.branchName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-line/customer-credit-line.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;